// Ubicación en el repo: src/lib/hearingaidAlerts.js
// Alertas de control de audífonos para Agenda (solo módulo ORL) — replica
// renderControlAlerts() de prototipo-actual.html (líneas ~1249-1273):
// controles no realizados (done=false) con fecha vencida o dentro de los
// próximos 7 días, de la sucursal activa. RLS (hearingaid_controls_select)
// ya filtra por sucursal vía has_branch_access(h.branch_id), esto solo
// agrega el filtro de fecha/estado.
import { supabase } from './supabaseClient';
import { todayISO, addDaysISO } from './format';

export async function listControlAlerts({ branchId }) {
  if (!branchId) return [];
  const today = todayISO();
  const soon = addDaysISO(today, 7);
  const { data, error } = await supabase
    .from('hearingaid_controls')
    .select(
      'id, date, hearing_aid_id, hearingaids!inner(id, branch_id, patients(id, nombre, apellido, segundo_nombre, segundo_apellido))'
    )
    .eq('done', false)
    .is('deleted_at', null)
    .is('hearingaids.deleted_at', null)
    .eq('hearingaids.branch_id', branchId)
    .lte('date', soon)
    .order('date', { ascending: true });
  if (error) throw error;
  return (data ?? []).map((c) => ({
    id: c.id,
    date: c.date,
    overdue: c.date < today,
    patient: c.hearingaids?.patients || null,
  }));
}
